/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import useForm from "../../hooks/useForm";

import Form from "../Form";
import Modal, { ModalHeader } from "../Modal";
import { createNotice, deleteNotice, modifyNotice } from "../../apis/boards";
import { NOTICE_TOP_EXPOSURE, TAX_BOARD } from "../../constants/NOTICE";
import systemAlert from "../../utils/systemAlert";
import { viewLoading } from "../../utils/loading";
import Profile from "../Profile";
import { dateToViewFormatWithDayNameWithTime } from "../../utils/date";
import NoticeIcon from "../../assets/images/icon/notice-icon.svg";
import Icon from "../Icon";
import { toast } from "../../utils/toast";

const defaultForm = {
  topExposure: "1",
  title: "",
  content: "",
  fileIdxes: [],
  type: "tax_notice"
};
const TaxBoard = ({ open, setOpen, selectedItem, setSelectedItem, submit }) => {
  const modalEl = useRef(null);
  const [minHeight, setMinHeight] = useState(0);
  const [mode, setMode] = useState("create");
  const [buttons, setButtons] = useState([]);

  const reset = () => {
    setSelectedItem(null);
    setMinHeight(0);
    setOpen(false);
  };

  const close = (e) => {
    if (e) {
      e.preventDefault();
    }
    submit && submit();
    reset();
  };


  const [fields, setFields] = useState([]);

  const validate = ({
    title,
    content
  }) => {
    let errors = {};

    if (!title) errors.title = "제목은 필수입니다.";
    if (!content) errors.content = "내용은 필수입니다.";
    return errors;
  };

  const _submit = (_form) => {
    const { type, ...body } = _form;
    if (mode === "create") {
      systemAlert(`"${TAX_BOARD.find(f => f.value === type)?.label}"를(을) 작성하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소"
          },
          {
            label: "승인",
            onClick: () => {
              viewLoading(true);
              createNotice(body, type)
                .then((res) => {
                  toast.info("등록되었습니다");
                  close();
                })
                .finally(() => {
                  viewLoading(false);
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`"${_form.title}"를(을) 수정하시겠습니까?`, {
        buttons: [
          {
            color: "text",
            label: "취소"
          },
          {
            label: "승인",
            onClick: () => {
              modifyNotice(body, type)
                .then(() => {
                  toast.info("수정되었습니다.");
                  close();
                });
            }
          }
        ]
      });
    }
  };

  const deleteSubmit = () => {
    systemAlert(`"${form.title}" 삭제하시겠습니까?`, {
      buttons: [
        {
          color: "text",
          label: "취소"
        },
        {
          color: "red",
          label: "삭제",
          onClick: () => {
            deleteNotice(form.idx, form.type)
              .then(() => {
                window.location.reload();
                // close()
                // systemAlert("삭제 되었습니다.", [
                //   {
                //     label: "확인",
                //     onClick: () => {
                //     }
                //   }
                // ])

              });
          }
        }
      ]
    });
  };

  const modifyMode = () => {
    setMode("modify");
  };

  const {
    form,
    errors,
    setForm,
    handleOnChange,
    handleSubmit,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
    validate,
    fields
  );

  useEffect(() => {
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm(selectedItem);
      setOriginForm(selectedItem);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);

  useEffect(() => {
    setButtons([
      {
        color: "text",
        label: "닫기",
        onClick: close
      },
      {
        isHide: mode !== "detail",
        label: "수정하기",
        onClick: modifyMode
      },
      {
        isHide: mode !== "modify",
        label: "수정",
        onClick: handleSubmit
      },
      {
        isHide: mode !== "create",
        label: "글쓰기",
        onClick: handleSubmit
      },
      {
        isHide: mode !== "detail",
        color: "red",
        label: "삭제",
        onClick: deleteSubmit
      },
    ]);
  }, [mode]);
  useEffect(() => {
    setFields([
      {
        type: selectedItem ? "text" : "radio",
        key: "type",
        title: "개시대상",
        options: {
          list: TAX_BOARD
        },
        onValue: (v) => {
          return TAX_BOARD.find(f => f.value === v)?.label || v;
        },
      },
      {
        isHide: () => {
          return mode === "detail";
        },
        title: "노출정보",
        key: "topExposure",
        type: "select",
        className: "zIndex-0",
        options: {
          list: NOTICE_TOP_EXPOSURE,
        },
      },
      {
        title: "제목",
        key: "title",
        type: "input",
      },
      {
        isHide: mode === "create",
        title: "작성자",
        type: "component",
        key: "title",
        component: (v) => {
          const { data } = v;
          return <><Profile data={data?.writeEmployee}></Profile></>;
        }
      },
      {
        isHide: mode === "create",
        title: "작성일",
        type: "component",
        component: () => {
          return <>{dateToViewFormatWithDayNameWithTime(selectedItem?.createdTime)}</>;
        }
      },
      {
        title: "내용",
        key: "content",
        type: "editor",
      },
      {
        title: "첨부파일",
        key: "fileIdxes",
        type: "dropzone",
        required: false,
      },
    ]);
  }, [mode, selectedItem]);

  return (
    <Modal
      isOpen={open}
      toggle={close}
    >
      <div
        className="notice-write"
        ref={modalEl}
        style={{
          minHeight
        }}
      >
        <ModalHeader>
          <Icon src={NoticeIcon} />&nbsp;
          {mode === "detail" && selectedItem ? selectedItem.title : mode === "create" ? "게시물작성" : "게시물수정"}
        </ModalHeader>
        <Form
          mode={mode}
          isRequiredShow={true}
          fields={fields}
          form={form}
          onChange={handleOnChange}
          buttons={buttons}
          errors={errors}
        />
      </div>
    </Modal>
  );
};


export default TaxBoard;
